import { GlobalConfigType } from 'actions'
import { FieldOrigin, isCustomOrigin, IVisibleProp, LoanFieldProps } from 'config'
import { getLoanInputFields } from 'config/loan.input.fields.constants'
import { store } from 'reducers'

import { combineObjectsDeep } from './convertor'

export const getLoanFieldProps = (fieldOrigin: FieldOrigin) => {
  const { globalConfigReducer } = store.getState()
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (!loanFieldProperties || !loanFieldProperties[fieldOrigin]) return {}
  return loanFieldProperties[fieldOrigin]
}

export const getInvisibleFields = (fieldOrigin: FieldOrigin, loan?: any) => {
  const {
    globalConfigReducer,
    loanDetail,
    borrower,
    auth: {
      profile: { accountType, email, isBorrower, warehouseApproved },
    },
    loan: loanData,
  } = store.getState()

  if (!loan) loan = loanData

  let data = {
    [FieldOrigin.LoanStructure]: loan,
    [FieldOrigin.BorrowerInformation]: {
      ...borrower['borrower'],
      ...(borrower['borrower'].customInformation?.[FieldOrigin.BorrowerInformation] || {}),
    },
    [FieldOrigin.PropertyInformation]: loan,
  } as LoanFieldProps
  const { type: loanType } = loan

  data = combineObjectsDeep(data, borrower['borrower'].customInformation)
  data[FieldOrigin.ManageAccount] = {
    warehouseApproved,
  }

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (!loanFieldProperties || !loanFieldProperties[fieldOrigin]) return []

  const fieldProps: Record<string, IVisibleProp> = loanFieldProperties[fieldOrigin]

  return Object.keys(fieldProps).filter((key) => {
    let { visible, visibleLogic, visibleAccountTypes, visibleLoanTypes } = fieldProps[key]
    if (visible === false) return true

    if (visibleAccountTypes) {
      if (!accountType && isBorrower && visibleAccountTypes['borrower'] == false) return true

      if (visibleAccountTypes['self_creator'] !== false && loanDetail.parties?.creator?.email == email) {
      } else if (visibleAccountTypes[accountType] === false) return true
    }

    if (loanType !== undefined && visibleLoanTypes && visibleLoanTypes[loanType] === false) return true

    if (!visibleLogic || !visibleLogic.length) return false
    visibleLogic = visibleLogic.filter((v) => {
      if (!v || !v.length) return false
      return !!v.filter((v) => !!v && !!v.fieldOrigin && !!v.fieldKey && v.value !== undefined).length
    })
    if (!visibleLogic.length) return false

    const isVisible = !!visibleLogic.filter((andLogics) => {
      return (
        andLogics.length ==
        andLogics.filter((logic) => {
          const { fieldOrigin, fieldKey, value: sampleValue } = logic
          const inputedValue = (data[fieldOrigin] || {})[fieldKey]
          return inputedValue == sampleValue
        }).length
      )
    }).length

    return !isVisible
  })
}

export const removeInvisibleFields = (loan: any, fieldOrigin: FieldOrigin, visibleFields: string[]) => {
  const invisibleFields = getInvisibleFields(fieldOrigin, loan)
  return visibleFields.filter((v) => !invisibleFields.includes(v))
}

export const setBorrowerDefaultData = (
  data: { borrower: Record<string, any>; coBorrower: Record<string, any> },
  fieldProps: LoanFieldProps,
) => {
  const borrowerInfo = fieldProps[FieldOrigin.BorrowerInformation]
  const loanInputFields = getLoanInputFields()
  const borrowerInputFields = loanInputFields[FieldOrigin.BorrowerInformation]

  if (!borrowerInfo) return data
  ;['borrower', 'coBorrower'].forEach((_boKey) => {
    const boKey = _boKey as 'borrower' | 'coBorrower'
    if (!data[boKey]) data[boKey] = {}
    Object.keys(borrowerInputFields).forEach((key) => {
      if (!['', null, undefined].includes(data[boKey][key])) return
      if (borrowerInfo[key] && borrowerInfo[key].defaultValue !== undefined && borrowerInfo[key].defaultValue !== '')
        data[boKey][key] = borrowerInfo[key].defaultValue
    })
  })

  Object.keys(fieldProps)
    .filter((origin) => isCustomOrigin(origin))
    .forEach((customOriginKey) => {
      const customInfo = fieldProps[customOriginKey]
      if (!customInfo) return data

      const boKey = 'borrower'
      if (!data[boKey]) data[boKey] = {}
      if (!data[boKey]['customInformation']) data[boKey]['customInformation'] = {}
      const customInfoValue = data[boKey]['customInformation'][customOriginKey] || {}
      Object.keys(customInfo).forEach((key) => {
        if (customInfoValue && !['', null, undefined].includes(customInfoValue[key])) return
        if (customInfo[key] && customInfo[key].defaultValue !== undefined && customInfo[key].defaultValue !== '')
          customInfoValue[key] = customInfo[key].defaultValue
      })
      data[boKey]['customInformation'][customOriginKey] = customInfoValue
    })

  return data
}

export const setLoanDefaultData = (data: Record<string, any>, fieldProps: LoanFieldProps) => {
  const fieldOrigins = [FieldOrigin.LoanStructure, FieldOrigin.PropertyInformation]
  const loanInputFields = getLoanInputFields()

  for (const fieldOrigin of fieldOrigins) {
    const prop = fieldProps[fieldOrigin]
    if (!prop) continue

    Object.keys(loanInputFields[fieldOrigin]).forEach((key) => {
      const value = data[key]
      if (!['', null, undefined].includes(value)) return

      if (prop[key] && prop[key].defaultValue !== undefined && prop[key].defaultValue !== '')
        data[key] = prop[key].defaultValue
    })
  }

  return data
}
